import { z } from 'zod';

import { SituacaoMatriculaEnum, TipoAtendimentoEnum } from './enums';
import type { MotivoEncerramentoMatricula, SituacaoMatricula, TipoAtendimento } from './enums';
import { HorarioCreateInput } from './horarios.dto';

export type MatriculaOutput = {
  id: string;
  alunoId: string;
  professorId: string;
  materiaId: string;
  estagio: string | null;
  tipoAtendimento: TipoAtendimento;
  situacao: SituacaoMatricula;
  observacoes: string | null;
  desativadoEm: Date | null;
  motivoEncerramento: MotivoEncerramentoMatricula | null;
};

export const MatriculaCreateInput = z
  .object({
    professorId: z.uuid(),
    materiaId: z.uuid(),
    estagio: z.string().optional(),
    tipoAtendimento: TipoAtendimentoEnum,
    observacoes: z.string().optional(),
    horarios: z.array(HorarioCreateInput).max(7).optional(),
  })
  .superRefine((input, ctx) => {
    const dias = new Set<string>();
    for (const [index, horario] of (input.horarios ?? []).entries()) {
      if (dias.has(horario.diaSemana)) {
        ctx.addIssue({
          code: 'custom',
          path: ['horarios', index, 'diaSemana'],
          message: 'Cada dia da semana pode aparecer apenas uma vez.',
        });
      }
      dias.add(horario.diaSemana);
    }
  });

export const MatriculaUpdateInput = z
  .object({
    professorId: z.uuid().optional(),
    materiaId: z.uuid().optional(),
    estagio: z.string().nullable().optional(),
    tipoAtendimento: TipoAtendimentoEnum.optional(),
    situacao: SituacaoMatriculaEnum.optional(),
    observacoes: z.string().nullable().optional(),
    horarios: z.array(HorarioCreateInput).max(7).optional(),
  })
  .strict()
  .superRefine((input, ctx) => {
    const dias = new Set<string>();
    for (const [index, horario] of (input.horarios ?? []).entries()) {
      if (dias.has(horario.diaSemana)) {
        ctx.addIssue({
          code: 'custom',
          path: ['horarios', index, 'diaSemana'],
          message: 'Cada dia da semana pode aparecer apenas uma vez.',
        });
      }
      dias.add(horario.diaSemana);
    }
  });

export type MatriculaOutputType = MatriculaOutput;
export type MatriculaCreateInputType = z.infer<typeof MatriculaCreateInput>;
export type MatriculaUpdateInputType = z.infer<typeof MatriculaUpdateInput>;
